module.exports = __webpack_public_path__ + "img/PDAC1_Plasma.022df05b.png";